// Copies an image (any format) to the clipboard as PNG, which every app can paste.
async function pngBlob(src: string): Promise<Blob> {
  const res = await fetch(src, { credentials: 'include' });
  if (!res.ok) throw new Error('image');
  const blob = await res.blob();
  if (blob.type === 'image/png') return blob;
  const bitmap = await createImageBitmap(blob);
  const canvas = document.createElement('canvas');
  canvas.width = bitmap.width; canvas.height = bitmap.height;
  canvas.getContext('2d')!.drawImage(bitmap, 0, 0);
  return new Promise<Blob>((ok, fail) => canvas.toBlob(b => (b ? ok(b) : fail(new Error('png'))), 'image/png'));
}
export async function copyImageToClipboard(src: string): Promise<void> {
  const desktop = (window as any).malvoDesktop;
  // Desktop app: write through the system clipboard directly.
  if (desktop?.copyImage) {
    const blob = await pngBlob(src);
    if (await desktop.copyImage(new Uint8Array(await blob.arrayBuffer()))) return;
    throw new Error('clipboard');
  }
  // Browser: hand the clipboard a promise right away, so the click still counts as the user's action.
  await navigator.clipboard.write([new ClipboardItem({ 'image/png': pngBlob(src) })]);
}
